import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Col,
  Form,
  Row,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetInwardApprovalDetailByID,
  POST_InwardApprovalUpdateStatus,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import { errorMessage, successMessage } from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";

const AddInwardApproval = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [showMaterialInfoImagesModal, setShowMaterialInfoImagesModal] =
    useState(false);

  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showInwardApprovalHistModal, setShowInwardApprovalHistModal] =
    useState(false);

  const [listOfMaterialImages, setListOfMaterialImages] = useState([]);
  const [listOfMachiningDetails, setListOfMachiningDetails] = useState([]);
  const [showMachiningDetailsModal, setShowMachiningDetailsModal] =
    useState(false);

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    StatusRemarks: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 5)
          return Yup.string().trim().required("Remarks is required field");
        return schema;
      },
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      InwardNo: "",
      InwardDate: "",
      CustomerName: "",
      ProjectName: "",
      ProjectDetails: "",
      LetterRefNo: "",
      StempWriteup: "",
      StampWriteUpName: "",
      StampImageFilePath: "",
      MaterialReceiveVia: "",
      ReceiveRemarks: "",
      MaterialTakenByUserName: "",
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      StatusRemarks: "",
      ReferenceByName: "",
      InwardCurrentStatus: 0,
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListOfMaterials: [],
      ListOfModeDetails: [],
      ListOfInwardApprovalHist: [],
      ListOfLetterRefDoc: [],
      btnSubmitType: 5,
      InwardRewiseAndRectifyActionStatus: true,
      IsHold: false,
      IsNDT: false,
      IsFoodTesting: false,
      RequestTypeName: "",
      CustomerRepresentativeName: "",
      SamplingByName: "",
      RequestType: 0,
      SamplingBy: 0,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      InwardDate,
      CustomerName,
      ProjectName,
      ProjectDetails,
      LetterRefNo,
      StempWriteup,
      InwardCurrentStatus,
      StampImageFilePath,
      MaterialReceiveVia,
      ReceiveRemarks,
      MaterialTakenByUserName,
      ExpectedDateOfDelivery,
      EDDRemarks,
      ReferenceByName,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfInwardApprovalHist,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      ListOfMaterials,
      ListOfModeDetails,

      InwardRewiseAndRectifyActionStatus,
      IsHold,
      IsNDT,
      IsFoodTesting,
      RequestTypeName,
      CustomerRepresentativeName,
      SamplingByName,
      RequestType,
      SamplingBy,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (PrimaryIdParam) {
      if (values?.IsHold == true) {
        return;
      }

      setIsLoading(true);

      let payload = {
        InwardIDEncrypt: window.atob(PrimaryIdParam),
        InwardCurrentStatus: values?.btnSubmitType,
        StatusRemarks: values?.StatusRemarks,
        ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
        SendEmailPermissions: AuthUser?.Permissions?.Email,
      };

      // console.log("log", payload);
      // return;

      post(POST_InwardApprovalUpdateStatus, payload)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              // navigate("/inward-approval");
              // navigate("/tc-test-allocation-list");
              navigate(-1);
            }, 1000);
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getMaterialInwardDetailByID();
    }
  }, []);

  const getMaterialInwardDetailByID = () => {
    setIsLoading(true);
    post(POST_GetInwardApprovalDetailByID, {
      InwardIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            ListOfLetterRefDoc: response?.ListOfInwardLetterRefImages,
            ListOfTPIDetails: response?.ListOfInwardTPI,
            ListOfModeDetails: response?.ListOfModeDetail,
            ListOfMaterials: response?.ListOfMaterialInfo,
            ListOfInwardApprovalHist: response?.ListOfInwardApprovalHist,
            StatusRemarks: "",
            btnSubmitType: 5,
            InwardCurrentStatus: response?.InwardCurrentStatus,
            InwardRewiseAndRectifyActionStatus:
              response?.InwardRewiseAndRectifyActionStatus,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersTestName: "",
      ParametersList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { ParametersTestName, ParametersList },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    setShowTestParametersModal(false);
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    setShowDefineMoreRatesModal(false);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Inward Approval</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <h6>Inward Information</h6>
                            </div>
                            <div>
                              {" "}
                              {ListOfInwardApprovalHist?.length > 0 ? (
                                <Link
                                  to="#"
                                  className="text-primary"
                                  onClick={() => {
                                    setShowInwardApprovalHistModal(true);
                                  }}
                                >
                                  View Approve History
                                </Link>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="col-xl-12 col-lg-12">
                                      <div className="row">
                                        <div className="col-xl-8 col-lg-4 mb-1">
                                          <ul>
                                            <li>
                                              {/* <label>Inward No :</label> */}
                                              <span>
                                                {InwardNo} {"|"} {InwardDate}
                                              </span>
                                            </li>
                                            {/* <li>
                                                <label>Inward Date :</label>
                                                <span className="ms-1">
                                                  {InwardDate}
                                                </span>
                                              </li> */}
                                          </ul>
                                        </div>
                                        <div className="col-xl-8 col-lg-4 mb-1">
                                          <ul>
                                            <li>
                                              {/* <label>Customer :</label> */}
                                              <span>{CustomerName}</span>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="col-xl-8 col-lg-4 mb-1">
                                          {/* <div className=""> */}
                                          <ul>
                                            <li>
                                              {/* <label>Project :</label> */}
                                              <span>{ProjectName}</span>
                                            </li>
                                          </ul>
                                          {/* </div> */}
                                        </div>
                                        {IsFoodTesting == false && (
                                          <div className="col-xl-8 col-lg-4 mb-1">
                                            {/* <div className=""> */}
                                            <ul>
                                              <li>
                                                {/* <label>
                                                  Sample Returnable :
                                                </label> */}
                                                {AuthUser?.Permissions
                                                  ?.DispatchMaterial == 1 ? (
                                                  <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                                    <label className="mb-1">
                                                      {IsMaterialReturnable ===
                                                      true
                                                        ? "Sample Returnable "
                                                        : " Sample Not Returnable"}
                                                    </label>
                                                  </text>
                                                ) : (
                                                  ""
                                                )}
                                                {"|"} <label>Stamp :</label>
                                                <span className="ms-1">
                                                  {StempWriteup}
                                                </span>
                                                &nbsp; &nbsp;
                                                {StampImageFilePath ? (
                                                  <Link
                                                    to="#"
                                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                                    className="icon-box icon-box-md me-1"
                                                    title="Stamp Download"
                                                    onClick={() => {
                                                      window.open(
                                                        StampImageFilePath,
                                                        "_blank",
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-file-image"></i>
                                                  </Link>
                                                ) : (
                                                  ""
                                                )}
                                              </li>
                                            </ul>
                                            {/* </div> */}
                                          </div>
                                        )}
                                        <div className="col-xl-6 col-lg-4 mb-1">
                                          <ul>
                                            <li>
                                              <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                                <label className="mb-1">
                                                  TPI Required :
                                                </label>
                                                <span className="ms-1">
                                                  {IsTPIRequired === true
                                                    ? "Yes"
                                                    : "No"}
                                                </span>
                                              </text>{" "}
                                              {ListOfTPIDetails?.length > 0 ? (
                                                IsTPIRequired === true ? (
                                                  <Link
                                                    to="#"
                                                    title="TPI Detail"
                                                    className="m-2 text-primary"
                                                    onClick={() => {
                                                      setShowTPIDetailModal(
                                                        true,
                                                      );
                                                    }}
                                                  >
                                                    View TPI
                                                  </Link>
                                                ) : (
                                                  ""
                                                )
                                              ) : (
                                                ""
                                              )}
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="col-xl-6 col-lg-4 mb-1">
                                          <ul>
                                            <li>
                                              <label>Letter Ref No :</label>
                                              <span className="ms-1">
                                                {LetterRefNo}&nbsp;&nbsp;
                                              </span>
                                              {ListOfLetterRefDoc?.length >
                                              0 ? (
                                                LetterRefNo ? (
                                                  <Link
                                                    to="#"
                                                    title="Letter Ref Doc"
                                                    className="text-primary"
                                                    onClick={() => {
                                                      setShowLetterRefDocModal(
                                                        true,
                                                      );
                                                    }}
                                                  >
                                                    View
                                                  </Link>
                                                ) : (
                                                  ""
                                                )
                                              ) : (
                                                ""
                                              )}
                                            </li>
                                          </ul>
                                        </div>
                                        {/* <div className="col-xl-6 col-lg-4">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>Letter Ref No :</label>
                                                <span className="ms-1">
                                                  {LetterRefNo}&nbsp;&nbsp;
                                                </span>
                                                {LetterRefNo ? (
                                                  <Link
                                                    to="#"
                                                    title="Letter Ref Doc"
                                                    className="text-primary"
                                                    onClick={() => {
                                                      setShowLetterRefDocModal(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    View
                                                  </Link>
                                                ) : (
                                                  ""
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                        </div> */}
                                        <div className="col-xl-12 col-lg-12">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>
                                                  Work Detail &nbsp;:{" "}
                                                </label>
                                                <span>
                                                  &nbsp;
                                                  {ProjectDetails}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        {IsFoodTesting == true && (
                                          <div className="col-xl-12 col-lg-12">
                                            <div className="">
                                              <ul>
                                                <li>
                                                  <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 pe-1">
                                                    <label className="mb-1">
                                                      Request Type &nbsp;:{" "}
                                                    </label>
                                                    <span>
                                                      &nbsp;
                                                      {SamplingByName
                                                        ? RequestTypeName +
                                                          "(" +
                                                          SamplingByName +
                                                          ")"
                                                        : RequestTypeName}
                                                    </span>
                                                  </text>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <h6>Modes</h6>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div
                                className="card-body p-2 table-responsive"
                                style={{ overflow: "auto", height: "250px" }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <div className="col-xl-12 col-lg-12">
                                      {ListOfModeDetails?.length > 0
                                        ? ListOfModeDetails?.map(
                                            (item, indx) => (
                                              <>
                                                <div className="row">
                                                  {/* <div className="col-xl-12 col-lg-12">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <h6>
                                                            {
                                                              item.ModeDetailName
                                                            }
                                                          </h6>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div> */}
                                                  <div className="col-xl-12 col-lg-12 mb-1">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          {/* <label>
                                                            Mode By :
                                                          </label> */}
                                                          <span className="ms-1">
                                                            {
                                                              item.ModeDetailName
                                                            }{" "}
                                                            {item.ModeTypeName ? (
                                                              <>
                                                                by{" "}
                                                                {
                                                                  item.ModeTypeName
                                                                }{" "}
                                                                to{" "}
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                            {item.ContactPerson}
                                                          </span>
                                                        </li>
                                                        {/* <li>
                                                          <label>
                                                            Contact Person :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item.ContactPerson}
                                                          </span>
                                                        </li> */}
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-12 col-lg-12  mb-1">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          {/* <label>
                                                            Customer :
                                                          </label> */}
                                                          <span className="ms-1">
                                                            {item.CustomerName}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-12 col-lg-12 mb-1">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          {/* <label>
                                                            Project :
                                                          </label> */}
                                                          <span className="ms-1">
                                                            {item.ProjectName}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  {item.Address ? (
                                                    <div className="col-xl-12 col-lg-12 mb-1">
                                                      <div className="">
                                                        <ul>
                                                          <li>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Address"
                                                            >
                                                              <i
                                                                className="fa fa-address-book"
                                                                aria-hidden="true"
                                                              ></i>
                                                            </Link>

                                                            <span className="ms-1">
                                                              {item.Address}
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {item.ContactPersonMobileNo ? (
                                                    <div className="col-xl-6 col-lg-4 mb-1">
                                                      <div className="">
                                                        <ul>
                                                          <li>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Mobile No"
                                                            >
                                                              <i
                                                                className="fa fa-phone"
                                                                aria-hidden="true"
                                                              ></i>
                                                            </Link>

                                                            <span className="ms-1">
                                                              {
                                                                item.ContactPersonMobileNo
                                                              }
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {item.ContactPersonEmailID ? (
                                                    <div className="col-xl-6 col-lg-4 mb-1">
                                                      <div className="">
                                                        <ul>
                                                          <li>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Email"
                                                            >
                                                              <i
                                                                className="fa fa-envelope"
                                                                aria-hidden="true"
                                                              ></i>
                                                            </Link>

                                                            <span className="ms-1">
                                                              {
                                                                item.ContactPersonEmailID
                                                              }
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                                <hr className="mt-1 mb-1"></hr>
                                              </>
                                            ),
                                          )
                                        : " "}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <h6>Other Information</h6>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-body p-2">
                                <Row>
                                  <Col lg={12}>
                                    <div className="col-xl-12 col-lg-12">
                                      <div className="row">
                                        <div className="col-xl-6 col-lg-4">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>Expected Date :</label>
                                                <span className="ms-1">
                                                  {ExpectedDateOfDelivery}
                                                </span>
                                              </li>
                                              <li>
                                                <label>
                                                  Material Taken By :
                                                </label>
                                                <span className="ms-1">
                                                  {MaterialTakenByUserName}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-4">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>
                                                  Sample Received Via :
                                                </label>
                                                <span className="ms-1">
                                                  {MaterialReceiveVia}
                                                </span>
                                              </li>
                                              <li>
                                                <label>Reference By :</label>
                                                <span className="ms-1">
                                                  {ReferenceByName}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-4">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>Representative :</label>
                                                <span className="ms-1">
                                                  {CustomerRepresentativeName}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>
                                                  Delivery Remarks :
                                                </label>
                                                <span className="ms-1">
                                                  {EDDRemarks}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12">
                                          <div className="">
                                            <ul>
                                              <li>
                                                <label>
                                                  Received Remarks :
                                                </label>
                                                <span className="ms-1">
                                                  {ReceiveRemarks}
                                                </span>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {InwardCurrentStatus != 5 ||
                        InwardRewiseAndRectifyActionStatus == true ? (
                          <Row>
                            <Col lg={12}>
                              <Field
                                label="Remarks"
                                name="StatusRemarks"
                                placeholder={"Enter Remarks"}
                                component={CustomTextArea}
                                rows={4}
                                maxLength={200}
                              />
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-header p-2">
                            <h4 className="card-title">Material Information</h4>
                          </div>
                          <div className="card-body p-2">
                            <div className="basic-form">
                              <Accordion
                                className="accordion accordion-primary"
                                defaultActiveKey="0"
                              >
                                {ListOfMaterials?.length > 0
                                  ? ListOfMaterials?.map((item, index) => (
                                      <Accordion.Item
                                        className="accordion-item"
                                        key={index}
                                        eventKey={index}
                                      >
                                        <Accordion.Header className="accordion-header rounded-lg">
                                          <b>TC No : </b> &nbsp;
                                          {item.TCNo} &nbsp;
                                          {item?.IsHold == true && (
                                            <>
                                              <b>[Hold]</b>
                                              <OverlayTrigger
                                                trigger={["hover", "focus"]}
                                                key={index}
                                                responsive={true}
                                                overlay={
                                                  <Tooltip className="toltip-popover">
                                                    <strong className="p-1">
                                                      <label>Hold:</label>{" "}
                                                      {item?.HoldReason}
                                                    </strong>
                                                  </Tooltip>
                                                }
                                              >
                                                <span>
                                                  <i
                                                    className="fa fa-info-circle ms-2"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "#9698ab",
                                                    }}
                                                  ></i>
                                                </span>
                                              </OverlayTrigger>
                                            </>
                                          )}
                                        </Accordion.Header>
                                        <Accordion.Collapse eventKey={index}>
                                          <div
                                            className="accordion-body"
                                            style={{
                                              // height: "180px",
                                              overflowX: "auto",
                                            }}
                                          >
                                            <div className="row">
                                              <div className="col-xl-12 col-lg-12">
                                                <div className="row">
                                                  {/* <div className="col-xl-12 col-lg-12">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Department :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item.DepartmentName
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div> */}
                                                  <div className="col-xl-12 col-lg-12">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Sample Name :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item.SampleDetail}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Condition :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item.Condition}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Size{" "}
                                                            {IsFoodTesting ==
                                                              true &&
                                                              " (Sample Quantity)"}
                                                            :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item.Size}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  {IsNDT == true && (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Die No :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.DieNo}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Heat No :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.HeatNo}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                DRG No :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.DRGNo}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Thickness (mm) :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.Thikness}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Area to be
                                                                Covered :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.AreatoBeCovered
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Radiation Energy
                                                                :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.RadiationEnergy
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Density :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.Density}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sensitivity :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.Sensitivity
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Material :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item.MaterialName
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Sample Packing :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.SamplePacking
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Lot No :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item?.LotNo}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Received Quantity :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.ReceivedQuantity
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Qty (In MT) :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item?.QtyInMT}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  {RequestType == 2 ||
                                                  SamplingBy == 1 ? (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sampling
                                                                Procedure :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SamplingProcedure
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sampling Date :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SamplingDate
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sampler Name :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SamplerName
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sampling
                                                                Location :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SamplingLocation
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Seal No :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.SealNo}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {RequestType == 2 ? (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Country Of
                                                                Export :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.CountryOfExport
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Consignment
                                                                Detail :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.ConsignmentDetail
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sealing Date :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SealingDate
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                No Of Bag :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.NoOfBag}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}

                                                  {RequestType == 3 ||
                                                  SamplingBy == 2 ? (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sample Drawn By
                                                                :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SampleDrawnBy
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {RequestType == 1 &&
                                                  SamplingBy == 1 ? (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Job Order No :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.JobOrderNumber
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}

                                                  {RequestType == 2 ? (
                                                    ""
                                                  ) : (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sample
                                                                Appearance :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SampleAppearance
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Sample Batch
                                                                Code :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SampleBatchCode
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Customer
                                                                Provided Details
                                                                :
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.CustomerProvidedSampleDetail
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Marking :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.Marking}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Mfg Date :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.MfgDate}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Exp Date :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.ExpDate}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Remark :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item?.Remark}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Decision Remark :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.DecisionRemark
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Temperature :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item?.Temperature}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Any Subcontracted
                                                            Test Activity :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item?.AnySubcontractedTestActivity
                                                              ? "Yes"
                                                              : "No"}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Reason for
                                                            Subcontracted
                                                            Activity :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.ReasonforSubcontractedActivity
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Statement of
                                                            Confirmity Required
                                                            :
                                                          </label>
                                                          <span className="ms-1">
                                                            {item?.StatementofConfirmityRequired
                                                              ? "Yes"
                                                              : "No"}
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Regularity Type :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.RegularityName
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Regularity Category
                                                            Type :
                                                          </label>
                                                          <span className="ms-1">
                                                            {
                                                              item?.RegularityCategoryTypeName
                                                            }
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  {item?.RegularityType == 3 &&
                                                  item?.RegularityCategoryType ==
                                                    10 ? (
                                                    <>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Type of
                                                                Facility:
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.TypeofFacility
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Source of Water:
                                                              </label>
                                                              <span className="ms-1">
                                                                {
                                                                  item?.SourceofWater
                                                                }
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}

                                                  <div className="col-xl-6 col-lg-6">
                                                    <div className="">
                                                      <ul>
                                                        <li>
                                                          <label>
                                                            Images&nbsp;:{" "}
                                                          </label>
                                                          <span>
                                                            &nbsp;
                                                            <Link
                                                              to="#"
                                                              title="Images"
                                                              className="m-2 text-primary"
                                                              onClick={() => {
                                                                setShowMaterialInfoImagesModal(
                                                                  true,
                                                                );
                                                                setListOfMaterialImages(
                                                                  item.ListOfMaterialImages,
                                                                );
                                                              }}
                                                            >
                                                              View
                                                            </Link>
                                                          </span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                  {AuthUser?.Permissions
                                                    ?.Machining == 1 &&
                                                    IsNDT == false &&
                                                    IsFoodTesting == false && (
                                                      <div className="col-xl-6 col-lg-6">
                                                        <div className="">
                                                          <ul>
                                                            <li>
                                                              <label>
                                                                Machining :
                                                              </label>
                                                              <span className="ms-1">
                                                                {item.IsMachining ? (
                                                                  <Link
                                                                    to="#"
                                                                    title="Machining Details"
                                                                    className="m-2 text-primary"
                                                                    onClick={() => {
                                                                      setShowMachiningDetailsModal(
                                                                        true,
                                                                      );
                                                                      setListOfMachiningDetails(
                                                                        item.ListOfMachiningDetails,
                                                                      );
                                                                    }}
                                                                  >
                                                                    Yes
                                                                  </Link>
                                                                ) : (
                                                                  "No"
                                                                )}
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              </div>
                                              <Accordion
                                                className="accordion accordion-primary"
                                                defaultActiveKey={item?.ListOfMaterialTests?.map(
                                                  (_, index) => index,
                                                )} // Array of all eventKeys
                                                alwaysOpen
                                              >
                                                {item?.ListOfMaterialTests?.map(
                                                  (subitem, subindex) => (
                                                    <Accordion.Item
                                                      className="accordion-item"
                                                      key={subindex}
                                                      eventKey={subindex}
                                                    >
                                                      <Accordion.Header className="accordion-header rounded-lg">
                                                        {subitem.TestName}{" "}
                                                        &nbsp;
                                                      </Accordion.Header>
                                                      <Accordion.Collapse
                                                        eventKey={subindex}
                                                      >
                                                        <div
                                                          className="accordion-body"
                                                          style={{
                                                            // height: "180px",
                                                            overflowX: "auto",
                                                          }}
                                                        >
                                                          <div className="row">
                                                            <div className="col-xl-12 col-lg-6">
                                                              <div className="row">
                                                                <div className="col-xl-6 col-lg-4">
                                                                  <div className="">
                                                                    <ul>
                                                                      <li>
                                                                        <label>
                                                                          Department
                                                                          :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {
                                                                            subitem.DepartmentName
                                                                          }
                                                                        </span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>

                                                                <div className="col-xl-6 col-lg-4">
                                                                  <div className="">
                                                                    <ul>
                                                                      <li>
                                                                        <label>
                                                                          Material
                                                                          Group
                                                                          :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {
                                                                            subitem.ProductGroupName
                                                                          }
                                                                        </span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>

                                                                <div className="col-xl-6 col-lg-4">
                                                                  <div className="">
                                                                    <ul>
                                                                      <li>
                                                                        <label>
                                                                          Material
                                                                          Type :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {
                                                                            subitem.MaterialType
                                                                          }
                                                                        </span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                                {/* {IsFoodTesting ==
                                                                  true && (
                                                                  <div className="col-xl-6 col-lg-4">
                                                                    <div className="">
                                                                      <ul>
                                                                        <li>
                                                                          <label>
                                                                            Test
                                                                            Method
                                                                            :
                                                                          </label>
                                                                          <span className="ms-1">
                                                                            {
                                                                              subitem.TestMethod
                                                                            }
                                                                          </span>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                )} */}
                                                                <div className="col-xl-6 col-lg-4">
                                                                  <div className="">
                                                                    <ul>
                                                                      <li>
                                                                        <label>
                                                                          Ref.
                                                                          Standard
                                                                          :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {subitem.ReferenceStandard
                                                                            ? subitem.ReferenceStandard
                                                                            : "Not Selected"}
                                                                        </span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                                {IsNDT ==
                                                                  true && (
                                                                  <div className="col-xl-6 col-lg-4">
                                                                    <div className="">
                                                                      <ul>
                                                                        <li>
                                                                          <label>
                                                                            Acceptance
                                                                            Standard
                                                                            :
                                                                          </label>
                                                                          <span className="ms-1">
                                                                            {subitem?.AcceptanceStandard
                                                                              ? subitem?.AcceptanceStandard
                                                                              : "Not Selected"}
                                                                          </span>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                )}
                                                                {IsNDT ==
                                                                  false &&
                                                                  IsFoodTesting ==
                                                                    false && (
                                                                    <>
                                                                      <div className="col-xl-6 col-lg-4">
                                                                        <div className="">
                                                                          <ul>
                                                                            <li>
                                                                              <label>
                                                                                Test
                                                                                Count
                                                                                :
                                                                              </label>
                                                                              <span className="ms-1">
                                                                                {
                                                                                  subitem.TestCount
                                                                                }
                                                                              </span>
                                                                            </li>
                                                                          </ul>
                                                                        </div>
                                                                      </div>
                                                                      {AuthUser
                                                                        ?.Permissions
                                                                        ?.Account ===
                                                                      1 ? (
                                                                        <div className="col-xl-6 col-lg-4">
                                                                          <div className="">
                                                                            <ul>
                                                                              <li>
                                                                                <label>
                                                                                  Billing
                                                                                  Qty
                                                                                  :
                                                                                </label>
                                                                                <span className="ms-1">
                                                                                  {
                                                                                    subitem.BillingQty
                                                                                  }
                                                                                </span>
                                                                              </li>
                                                                            </ul>
                                                                          </div>
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </>
                                                                  )}
                                                                {/* <div className="col-xl-6 col-lg-6">
                                                                  <div className="">
                                                                    <ul> */}

                                                                {/* <li>
                                                                        <label>
                                                                          Unit :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {
                                                                            "Unit"
                                                                          }
                                                                        </span>
                                                                      </li> */}
                                                                {/* <li>
                                                                        <label>
                                                                          Machining
                                                                          :
                                                                        </label>
                                                                        <span className="ms-1">
                                                                          {subitem.IsMachining ===
                                                                          true
                                                                            ? "Yes"
                                                                            : "No"}
                                                                        </span>
                                                                      </li> */}
                                                                {/* </ul>
                                                                  </div>
                                                                </div> */}
                                                                {subitem.TestNote ? (
                                                                  <div className="col-xl-12 col-lg-12">
                                                                    <div className="">
                                                                      <ul>
                                                                        <li>
                                                                          <label>
                                                                            Test
                                                                            Note
                                                                            :
                                                                          </label>
                                                                          <span className="ms-1">
                                                                            {
                                                                              subitem.TestNote
                                                                            }
                                                                          </span>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                {IsNDT ==
                                                                  false && (
                                                                  <>
                                                                    <div className="col-xl-6 col-lg-6">
                                                                      <div className="">
                                                                        <ul>
                                                                          <li>
                                                                            <label>
                                                                              Parameters
                                                                              :
                                                                            </label>
                                                                            <Link
                                                                              to="#"
                                                                              className="m-2 text-primary"
                                                                              title="View Parameters"
                                                                              onClick={() => {
                                                                                formikTestPrameters.setFieldValue(
                                                                                  "ParametersTestName",
                                                                                  subitem.TestName,
                                                                                );
                                                                                formikTestPrameters.setFieldValue(
                                                                                  "ParametersList",
                                                                                  subitem?.ListOfTestParameters,
                                                                                );

                                                                                setShowTestParametersModal(
                                                                                  true,
                                                                                );
                                                                              }}
                                                                            >
                                                                              View
                                                                            </Link>
                                                                          </li>
                                                                        </ul>
                                                                      </div>
                                                                    </div>
                                                                    <div className="col-xl-6 col-lg-4">
                                                                      <div className="">
                                                                        <ul>
                                                                          <li>
                                                                            <label>
                                                                              Ref.
                                                                              Standard
                                                                              Group
                                                                              :
                                                                            </label>
                                                                            <span className="ms-1">
                                                                              {subitem.RefStandardSubGroup
                                                                                ? subitem.RefStandardSubGroup
                                                                                : "Not Selected"}
                                                                            </span>
                                                                          </li>
                                                                        </ul>
                                                                      </div>
                                                                    </div>
                                                                  </>
                                                                )}
                                                                {AuthUser
                                                                  ?.Permissions
                                                                  ?.Account ==
                                                                1 ? (
                                                                  subitem
                                                                    ?.ListOfDefineMoreRates
                                                                    ?.length >
                                                                  0 ? (
                                                                    <>
                                                                      {IsNDT ==
                                                                      false ? (
                                                                        <div className="col-xl-6 col-lg-6">
                                                                          <div className="">
                                                                            <ul>
                                                                              <li>
                                                                                <label>
                                                                                  Define
                                                                                  More
                                                                                  Rates:
                                                                                </label>
                                                                                <Link
                                                                                  to="#"
                                                                                  className="m-2 text-primary"
                                                                                  title="View Define More Rates"
                                                                                  onClick={() => {
                                                                                    formikDefineMoreRates.setFieldValue(
                                                                                      "MoreTestRatesList",
                                                                                      subitem?.ListOfDefineMoreRates,
                                                                                    );

                                                                                    setShowDefineMoreRatesModal(
                                                                                      true,
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  View
                                                                                </Link>
                                                                              </li>
                                                                            </ul>
                                                                          </div>
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    ""
                                                                  )
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </Accordion.Collapse>
                                                    </Accordion.Item>
                                                  ),
                                                )}
                                              </Accordion>
                                            </div>
                                            <hr className="mt-0 mb-1"></hr>
                                          </div>
                                        </Accordion.Collapse>
                                      </Accordion.Item>
                                    ))
                                  : ""}
                              </Accordion>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="stickyBottomButtons">
                  <hr className="mt-0 mb-2"></hr>
                  {InwardCurrentStatus != 5 && IsHold == false ? (
                    <>
                      {" "}
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 5);
                        }}
                      >
                        <i className="fa-regular fa-circle-check"></i> Approved
                      </button>
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 7);
                        }}
                      >
                        <i className="fa-regular fa-circle-xmark"></i> Rejected
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {InwardRewiseAndRectifyActionStatus == true &&
                  IsHold == false ? (
                    <button
                      type="submit"
                      // className="btn btn-primary"
                      className="btn btn-primary btn-sm me-2"
                      onClick={() => {
                        formik.setFieldValue("btnSubmitType", 6);
                      }}
                    >
                      <i className="fa fa-rotate-left"></i> Revise & Rectify
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showMaterialInfoImagesModal}
          onHide={setShowMaterialInfoImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Images - Material Information</Modal.Title>
              <button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              ></button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="2%"></th>
                            <th width="98%" style={{ textAlign: "left" }}>
                              Image
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listOfMaterialImages?.length > 0 ? (
                            listOfMaterialImages?.map((item, indx) => (
                              <tr>
                                <td style={{ textAlign: "left" }}>
                                  {" "}
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    // title="Download"
                                    // onClick={() => {
                                    //   window.open(
                                    //     item.MaterialPhotoFilePath,
                                    //     "_blank"
                                    //   );
                                    // }}
                                    title="View"
                                    onClick={() => {
                                      window.open(item.MaterialPhotoFilePath);
                                    }}
                                  >
                                    {/* <i className="fa fa-download"></i> */}
                                    <i className="fa fa-eye" />
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <img
                                    src={
                                      item.MaterialPhotoFilePath
                                        ? item.MaterialPhotoFilePath
                                        : item.viewFile
                                    }
                                    alt={"Material Image"}
                                    style={{
                                      maxHeight: "50px",
                                      maxWidth: "50px",
                                    }}
                                  />
                                  {/* {item?.MaterialPhotoFilePath
                                    ? (item?.MaterialPhotoFilePath?.split("/"))[
                                        item?.MaterialPhotoFilePath?.split("/")
                                          .length - 1
                                      ]
                                    : ""} */}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTPIDetailModal}
          onHide={setShowTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="40%">TPI</th>
                            <th width="40%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTPIDetails?.length > 0 ? (
                            ListOfTPIDetails?.map((item, indx) => (
                              <tr key={indx}>
                                <td>{item.TPI}</td>
                                <td>{item.ContactPerson}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.TPIExpectedDate}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="2%"></th>
                            <th width="98%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr key={indx}>
                                <td style={{ textAlign: "left" }}>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item?.LetterRefImageFileName
                                    ? item?.LetterRefImageFileName
                                    : ""}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showInwardApprovalHistModal}
          onHide={setShowInwardApprovalHistModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Inward Approval History</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowInwardApprovalHistModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="InwardApprovalHist-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="InwardApprovalHist-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="25%">Inward Status</th>
                            <th width="25%">Created By Name</th>
                            <th width="15%">Created Date</th>
                            <th width="35%" style={{ textAlign: "left" }}>
                              Status Remarks
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfInwardApprovalHist?.length > 0 ? (
                            ListOfInwardApprovalHist?.map((item, indx) => (
                              <tr key={indx}>
                                <td>{item.InwardStatus}</td>
                                <td>{item.CreatedByName}</td>
                                <td>{item.CreatedOn}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.StatusRemarks}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowInwardApprovalHistModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showMachiningDetailsModal}
          onHide={setShowMachiningDetailsModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Machining Details</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMachiningDetailsModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="InwardApprovalHist-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="InwardApprovalHist-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="28%">Process Name</th>
                            <th width="27%">Process Note</th>
                            <th width="15%">Qty</th>
                            <th width="15%">Length</th>
                            <th width="15%" style={{ textAlign: "left" }}>
                              Thickness
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listOfMachiningDetails?.length > 0 ? (
                            listOfMachiningDetails?.map((item, indx) => (
                              <tr key={indx}>
                                <td>{item.ProcessName}</td>
                                <td>{item.MachiningNote}</td>
                                <td>{item.Qty}</td>
                                <td>{item.Length}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.Thickness}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMachiningDetailsModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTestParametersModal}
          onHide={setShowTestParametersModal}
          backdrop="static"
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestPrameters}>
              <Form onSubmit={formikTestPrameters.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{ParametersTestName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowTestParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div
                        className="table-responsive active-projects style-1 shorting"
                        style={{ maxHeight: "450px" }}
                      >
                        <div
                          id="TestParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="TestParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%"></th>
                                <th width="33%">Parameters</th>
                                <th width="33%">Test Method</th>
                                <th width="30%" style={{ textAlign: "left" }}>
                                  Unit
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ParametersList?.length > 0 ? (
                                ParametersList?.map((para, iPara) => (
                                  <tr key={iPara}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${iPara}`}
                                        name={`chkIsSelected${iPara}`}
                                        checked={para.IsSelected}
                                        disabled={true}
                                      />
                                    </td>
                                    <td className="p-1">
                                      {para?.ParameterName}
                                    </td>
                                    <td className="p-1">{para?.TestMethod}</td>
                                    <td
                                      className="p-1"
                                      style={{ textAlign: "left" }}
                                    >
                                      {para?.UnitName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                {/* <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowTestParametersModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer> */}
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="5%" className="ps-1"></th>
                                <th width="95%" style={{ textAlign: "left" }}>
                                  Rate Type
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((tRate, tRateindx) => (
                                  <tr key={`para_${tRateindx}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${tRateindx}`}
                                        name={`chkIsSelected${tRateindx}`}
                                        checked={tRate.IsSelected}
                                        disabled={true}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {tRate.RateTypeName}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddInwardApproval;
